/*
 * @Author: hehaishen
 * @Date: 2019-06-17 15:50:56
 * @LastEditors  : Please set LastEditors
 * @LastEditTime : 2020-01-13 14:00:09
 * @Description:
 */
import va from "./port";
//定义全局环境
export const env = {
    start: {
      // 开发环境
      api: "http://t.oms.api.bit-inc.cn/v1",
        hardwareApi: "http://t.emc.bitiot.com.cn/v1/", //test
        tiyixingApi:"http://t.api.weibao.tiyixing.com/v1",
        ossApi: "http://t.apistore.bitiot.com.cn/v1/",
        palmApi:'http://t.api.bit-wisdom.com/v1/', //http://t.api.bit-wisdom.com/v1
        bucket: "bit-test",
        leanCouldId: "opiCkQNyIeFG6aFa06k9xB4N-gzGzoHsz",
        leanCoulKey: "v8t55Vh3POoql0LmIHEfzY0a",
        socketIo: {
            pushUrl: 'ws://t.push.bit-inc.cn/',
            url: 'http://t.api.push.bit-inc.cn/device',
            'X-BP-KEY': "IhUbqcUViyhU9iqegw51OzYwwGU9WlIyhktc",
            'X-BP-ID': "AW5tLCE0IHgUTI6C7Ivs",
        }
    },
    dev: {
        // 开发环境
        api: "http://dev.oms.api.bit-inc.cn/v1/",
        hardwareApi: "http://dev.emc.bitiot.com.cn/v1/", //服务器
         //梯易行的接口
        tiyixingApi:"http://dev.api.weibao.tiyixing.com/v1",
        palmApi:'http://dev.api.bit-wisdom.com/v1/',
        ossApi: "http://t.apistore.bitiot.com.cn/v1/",
        bucket: "bit-test",
        leanCouldId: "opiCkQNyIeFG6aFa06k9xB4N-gzGzoHsz",
        leanCoulKey: "v8t55Vh3POoql0LmIHEfzY0a",
        socketIo: {
            pushUrl: 'ws://dev.push.bit-inc.cn/',
            url: 'http://dev.api.push.bit-inc.cn/device',
            'X-BP-KEY': "IhUbqcUViyhU9iqegw51OzYwwGU9WlIyhktc",
            'X-BP-ID': "AW5tLCE0IHgUTI6C7Ivs",
        }
    },
    prod: {
        //生产
        api: "http://oms.api.bit-inc.cn/v1",
         //梯易行的接口
        tiyixingApi:"https://api.weibao.tiyixing.com/v1",
        ossApi: "https://apistore.bitiot.com.cn/v1/",
        palmApi:'https://api.bit-wisdom.com/v1/',
        hardwareApi: "http://emc.bitiot.com.cn/v1/", //test
        bucket: "bit-smcm-img",
        leanCouldId: "VxhULbUBNj9cP8XGY5aAYcRg-gzGzoHsz",
        leanCoulKey: "JVkLfsueexEBkS0a4h9DgXYS",
        socketIo: {
            pushUrl: 'wss://push.bit-inc.cn/',
            url: 'https://api.push.bit-inc.cn/device',
            'X-BP-KEY': "d7Hwd8ZeinfzbW6fXRj510JHtcqrVs8Xyz3d",
            'X-BP-ID': "AW5uZ-bI-b8qKr-AlFPg",
        }
    },
    test: {
        //测试
        api: "http://t.oms.api.bit-inc.cn/v1",
        hardwareApi: "http://t.emc.bitiot.com.cn/v1/", //test
        tiyixingApi:"http://t.api.weibao.tiyixing.com/v1",
        ossApi: "http://t.apistore.bitiot.com.cn/v1/",
        palmApi:'http://t.api.bit-wisdom.com/v1/', //http://t.api.bit-wisdom.com/v1
        bucket: "bit-test",
        leanCouldId: "opiCkQNyIeFG6aFa06k9xB4N-gzGzoHsz",
        leanCoulKey: "v8t55Vh3POoql0LmIHEfzY0a",
        socketIo: {
            pushUrl: 'ws://t.push.bit-inc.cn/',
            url: 'http://t.api.push.bit-inc.cn/device',
            'X-BP-KEY': "IhUbqcUViyhU9iqegw51OzYwwGU9WlIyhktc",
            'X-BP-ID': "AW5tLCE0IHgUTI6C7Ivs",
        }
    }
};

export const bucketType = {
    "bit-ev-img": ["png", "jpg", "jpeg"],
    "bit-ev-file": [
        "txt",
        "bin",
        "doc",
        "docx",
        "pdf",
        "xlsx",
        "xls",
        "zip",
        "rar",
        "odt"
    ],
    "bit-ev-vidio": [
        "avi",
        "mpg",
        "mp4",
        "viv",
        "aiff",
        "mov",
        "mpeg",
        "ram",
        "qt"
    ]
};
export function currentEnv() {
    return va; // 'prod'
}



// WEBPACK FOOTER //
// ./src/utils/config.js